<template>
  <v-autocomplete color="blue-darken-2"
                  variant="outlined"
                  density="compact"
                  flat
                  append-icon=""
                  menu-icon="keyboard_arrow_down"
                  v-bind="$attrs"
  >
    <template v-if="$slots.prepend" #prepend>
      <slot name="prepend"></slot>
    </template>

    <template v-slot:prepend-inner>
      <!-- @slot Inner prepend slot. Replaces the default icon slot -->
      <slot name="prepend-inner"></slot>
    </template>

    <template v-slot:item="{ props }">
      <!-- @slot Item slot. -->
      <slot name="item" v-bind="props"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: 'AppAutocomplete',
  inheritAttrs: false,
}
</script>
<style scoped lang="scss">
@import "@/scss/border-tokens";

:deep(.v-input--horizontal .v-input__prepend) {
  margin: 0;
}
:deep(.v-field--variant-outlined .v-field__outline) {
  --v-field-border-opacity: .25;
  @include border-radius('border-radius-3');
}

:deep(.v-field) {
  --outline-color: rgb(var(--v-theme-border-secondary));
  --outline-width: #{get-width('border-width-1')};
  --text-color: rgb(var(--v-theme-text-secondary));
  --background-color: rgb(var(--v-theme-surface-primary));
  --v-disabled-opacity: 1;
  --placeholder-color: rgb(var(--v-theme-text-placeholder));
  color: var(--text-color);
  background-color: var(--background-color);

  &:not(.v-field--disabled):hover {
    --outline-color: rgb(var(--v-theme-border-secondary-hover));
  }

  &:not(.v-field--disabled):focus-within {
    --outline-color: rgb(var(--v-theme-border-info-bold));
    --outline-width: #{get-width('border-width-2')};
  }

  &.v-field--disabled {
    --text-color: rgb(var(--v-theme-text-disabled));
    --background-color: rgb(var(--v-theme-surface-disabled));
    --outline-color: rgb(var(--v-theme-border-disabled));
    --placeholder-color: rgb(var(--v-theme-text-disabled));
  }

  &.v-field--error {
    --outline-color: rgb(var(--v-theme-border-danger-bold)) !important;
  }
}

:deep(.v-field__input input::placeholder) {
  color: var(--placeholder-color) !important;
  opacity: 1;
}

:deep(.v-field__outline__start),
:deep(.v-field__outline__end) {
  border-color: var(--outline-color);
  border-top-width: var(--outline-width);
  border-bottom-width: var(--outline-width);
  opacity: 1;
}

:deep(.v-field__outline__notch::before) {
  border-color: var(--outline-color);
  border-top-width: var(--outline-width);
  opacity: 1;
}

:deep(.v-field__outline__notch::after) {
  border-color: var(--outline-color);
  border-bottom-width: var(--outline-width);
  opacity: 1;
}

:deep(.v-field__outline__start) {
  border-left-width: var(--outline-width);
}

:deep(.v-field__outline__end) {
  border-right-width: var(--outline-width);
}
</style>
